import { useMemo } from 'react';
import { useModuleAccess } from '@/core/permissions/useModuleAccess';
import { NAVIGATION_GROUPS, type NavGroup } from '@/config/navigationConfig';

export function useNavigationItems() {
  const { hasModule, isLoading } = useModuleAccess();

  const groups = useMemo<NavGroup[]>(() => {
    if (isLoading) return [];
    return NAVIGATION_GROUPS
      .map(g => ({ ...g, items: g.items.filter(i => hasModule(i.moduleCode)) }))
      .filter(g => g.items.length > 0);
  }, [hasModule, isLoading]);

  return { groups, isLoading };
}
